import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined"
import Button from "@mui/material/Button"
import CircularProgress from "@mui/material/CircularProgress"
import Typography from "@mui/material/Typography"
import { format } from "date-fns"
import * as fileDownload from "js-file-download"
import PropTypes from "prop-types"
import { useState } from "react"

import Row from "../../../common/components/Row"
import { isAdminDemoMode } from "../mockData"

/**
 * Downloads every row matching the table's active search/filters (not just the
 * current page) as CSV. `params` should be the query's `exportParams`.
 */
export default function AdminExportCsvButton({
  exportFn,
  params,
  filenamePrefix,
}) {
  const [isExporting, setIsExporting] = useState(false)
  const [errorMessage, setErrorMessage] = useState("")

  function handleExport() {
    setIsExporting(true)
    setErrorMessage("")
    exportFn(params)
      .then(({ data }) =>
        fileDownload(
          data,
          `${filenamePrefix}-${format(new Date(), "yyyy-MM-dd")}.csv`
        )
      )
      .catch(() => setErrorMessage("Export failed. Please try again."))
      .finally(() => setIsExporting(false))
  }

  return (
    <Row gap={1} sx={{ alignItems: "center" }}>
      <Button
        variant="outlined"
        size="small"
        onClick={handleExport}
        disabled={isExporting || isAdminDemoMode()}
        startIcon={
          isExporting ? (
            <CircularProgress size={16} />
          ) : (
            <FileDownloadOutlinedIcon />
          )
        }
      >
        Export CSV
      </Button>
      {errorMessage ? (
        <Typography variant="caption" color="error">
          {errorMessage}
        </Typography>
      ) : null}
    </Row>
  )
}

AdminExportCsvButton.propTypes = {
  exportFn: PropTypes.func.isRequired,
  params: PropTypes.object,
  filenamePrefix: PropTypes.string.isRequired,
}
